export default __webpack_public_path__ + "static/media/s_wdt_c_3_4.6a10ee38.mp3";